module.exports = __webpack_public_path__ + "static/media/photo161.9f14e876.jpg";